// ピックアップ／関連記事カードカルーセル（.js-pickup-carousel）。
// 1 枚ずつ送る多カード表示・無限ループ・スワイプ対応。
// 実体は共通エンジン（_carouselEngine.js）。ここはカード版の config を渡すだけ。
// 1 コマ＝実測カード幅。全カードがビューポートに収まる場合はエンジンが is-static を付け、
// カルーセルを無効化して静的な一列表示にする（CSS 側でクローン・ナビを隠す）。

import { createCarousel } from './_carouselEngine';

export function pickupCarousel() {
  document.querySelectorAll('.js-pickup-carousel').forEach((root) => {
    createCarousel(root, {
      trackSelector: '.js-pickup-carousel-track',
      viewportSelector: '.pickup-carousel-viewport',
      prevSelector: '.js-pickup-carousel-prev',
      nextSelector: '.js-pickup-carousel-next',
      counterSelector: '.js-pickup-carousel-counter',
      // data-loop="false" のカルーセルだけ無限ループを無効化（端で停止・繰り返さない）。既定はループ。
      loop: root.dataset.loop !== 'false',
      // 1 コマ＝実測カード幅（幅は HTML 側の width class 任せ）。
      measureStep: ({ slides }) => slides[0].getBoundingClientRect().width,
      // ループ用クローンを支援技術・タブ移動から除外する。
      onClone: (clone) => {
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
      },
    });
  });
}
